export default "__VITE_ASSET__6ae78faa__"